// @flow
import client, { saveJWTToken } from '../../client'

// Types
import type { UserLoginToken } from '../../api_types'

type Data = {
  email: string,
  password: string,
}

// Constants
export const LOGIN_ENDPOINT_V2 = '/auth/token'

/**
 * Login an user using its username and password
 * @param {Object} data User information
 * @param {string} data.username User username
 * @param {string} data.password User password
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const login = (data: Data): Promise<UserLoginToken> =>
  client.post(LOGIN_ENDPOINT_V2, { body: data }).then(saveJWTToken)

export default login
